var util = {
	//新增用户，非空判断
	checkLogin:function(login) {
		for (let a in login) {
			if(!login[a]){
				alert("请填写完整信息")
				return false;
			}
		}
		return true;
	},
	lempblackFixed:function(obj){
		obj.lc = parseFloat(obj.lc).toFixed(2);
		obj.pc = parseFloat(obj.pc).toFixed(2);
		obj.nmthc = parseFloat(obj.nmthc).toFixed(2);
	},
	dustFixed:function(obj) {
		obj.pm25 =  parseFloat(obj.pm25).toFixed(2);
		obj.pm10 =  parseFloat(obj.pm10).toFixed(2);
		obj.noise =  parseFloat(obj.noise).toFixed(2);
		obj.temp =  parseFloat(obj.temp).toFixed(2);
		obj.humidity =  parseFloat(obj.humidity).toFixed(2);
		obj.ws =  parseFloat(obj.ws).toFixed(2);
		obj.wp =  parseFloat(obj.wp).toFixed(2);
	},
	outDoorFixed:function(obj) {
		obj.vocs = obj.vocs.toFixed(2);
	},
	carRepairFixed:function(obj) {
		obj.vocs = parseFloat(obj.vocs).toFixed(2);
		obj.temp = parseFloat(obj.temp).toFixed(2);
		obj.nmthc = parseFloat(obj.nmthc).toFixed(2);
		obj.pc = parseFloat(obj.pc).toFixed(2);
		obj.bz = parseFloat(obj.bz).toFixed(2);
		obj.bzs = parseFloat(obj.bzs).toFixed(2);
	},
	timeToStringWithYear:function(time) {
		var date = new Date();
		date.setTime(time);
		var stringTime  = date.getFullYear()+'年'+ (date.getMonth()+1)+'月'+date.getDate()+'日'+date.getHours()+'时'+date.getMinutes()+'分';
		if(time==0){
			stringTime = "暂无上传记录"
		}
		return stringTime;
	},
	
	timeToStringWithMonth:function(time) {
		var date = new Date();
		date.setTime(time);
		var stringTime  = (date.getMonth()+1)+'月'+date.getDate()+'日'+date.getHours()+'时'+date.getMinutes()+'分';
		return stringTime;
	},
	
	timeToStringWithHour:function(time) {
		var date = new Date();
		date.setTime(time);
		var stringTime  = date.getHours()+'时'+date.getMinutes()+'分';
		return stringTime;
	},
	
	timeToStringForOffline:function(time) {
		var date = new Date();
		date.setTime(time);
		var stringTime  = (date.getMonth()+1)+'月'+(date.getDate()-1)+'日全天未开机';
		return stringTime;
	},
	
	switchPermission:function(str) {
		if(str=='高级管理员'){
			return 'maxkly';
		}else if(str == '普通管理员'){
			return 'ninenine';
		}else{
			return 'nomaluser';
		}
	},
	switchUser:function(str) {
		if(str=='maxkly'){
			return '高级管理员';
		}else if(str == 'ninenine'){
			return '普通管理员';
		}else{
			return '标准用户';
		}
	}
	
	
}
	
	

export{
	util
}